export const LOAD_GLOBAL_RIGHTS_SUCCESS = "LOAD_GLOBAL_RIGHTS_SUCCESS";
export const LOAD_GLOBAL_RIGHTS_STARTED = "LOAD_GLOBAL_RIGHTS_STARTED";
